import React, { Component } from 'react';
import './Deals.css';
import { DealItem } from './DealItem';
import SimpleSlider from '../SimpleSlider/SimpleSlider';
import { Img } from '../UI/UI';
import { getImgUrl, limitText } from '../../Utility/Utility';

class Deals extends Component {
  constructor(props) {
    super(props);
    this.image_url = getImgUrl();

    this.dealsSliderSettings = {
      dots: true,
      infinite: true,
      cssEase: 'linear',
      autoplay: false,
      lazyLoad: 'ondemand',
      slidesToShow: this.props.items != undefined ? this.props.items : 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    this.deals = [
      {
          title: "Earth Viaggi",
          desc: "Israele: City Break a Gerusalemme",
          price: "920€",
          link: "https://www.earthviaggi.it/tour/israele-city-break-a-gerusalemme",
          book_now: 'RESERVA YA',
          logo: '/Deals/EARTH_2017_DEF.jpg',
      },
      {
        title: "I Viaggi di Maurizio Levi",
        desc: "Israele – Fly & Drive tra storia fede e cultura",
        price: "970€",
        link: "https://www.viaggilevi.com/itinerario/israele-3/",
        book_now: 'RESERVA YA',
        logo: '/Deals/LogoIViaggidiMaurizioLevi.jpg',
      },
      
      {
        title: "Quality Group",
        desc: "Jerusalem City Break - Le struggenti atmosfere di Gerusalemme in un week-end dalle forti emozioni",
        price: "1,132€",
        link: "https://www.qualitygroup.it/tour/Israele/israweekcat20_Week-end-a-Gerusalemme?typeProduct=tour&tourDate=20211117#.YkrxHOdByUl",
        book_now: 'RESERVA YA',
        logo: '/Deals/logoQualityGroup.jpg',
      },
      {
        title: "Brevivet",
        desc: "Terra Santa: nel grembo della Fede. 8 giorni. Partenze 2022",
        price: "1,160€",
        link: "www.brevivet.it/viaggio.php/id_227/terra-santa-nel-grembo-della-fede-8-giorni-aereo.html",
        book_now: 'RESERVA YA',
        logo: '/Deals/Brevivet.jpg',
      },
      {
        title: "Diomira Travel",
        desc: "Pasqua a Gerualemme",
        price: "1,190€",
        link: "https://www.diomiratravel.com/itinerario/pellegrinaggio-terra-santa-pasqua-gerusalemme",
        book_now: 'RESERVA YA',
        logo: '/Deals/Diomira.jpg',
      },
      {
          title: "Going",
          desc: "Going to Israel!",
          price: "1,220€",
          link: "https://bluvacanze.it/vacanze-israele-going-tour-operator/",
          book_now: 'RESERVA YA',
          logo: '/Deals/Going_pos_282.jpg',
      },
      {
          title: "Press Tour",
          desc: "Il meglio di Israele",
          price: "1,364€",
          link: "https://www.turisanda.it/viaggi/israele/tel-aviv/il-meglio-di-israele",
          book_now: 'RESERVA YA',
          logo: '/Deals/Presstour_Maggiore.jpg',
      },
      {
          title: "Opera Romana Pellegrinaggi",
          desc: "al Cuore della Terra Santa",
          price: "1,390€",
          link: "https://www.operaromanapellegrinaggi.org/it/pellegrinaggi/pellegrinaggi/al-cuore-della-terra-santa",
          book_now: 'RESERVA YA',
          logo: '/Deals/OperaRomana.jpg',
      },
      {
        title: "Made",
        desc: "Sentieri di Gerusalemme",
        price: "1,435€",
        link: "https://www.turisanda.it/viaggi/israele/tel-aviv/sentieri-di-gerusalemme",
        book_now: 'RESERVA YA',
        logo: '/Deals/Made.jpg',
      },
      {
        title: "Shiruq",
        desc: "Israele, un tocco di misticismo",
        price: "1,600€",
        link: "https://www.shiruqviaggi.com/prodotto/un-tocco-di-misticismo/",
        book_now: 'RESERVA YA',
        logo: '/Deals/Logo_Shiruq.jpg',
      },
      {
        title: "Shiruq",
        desc: "L'armonia dei contrasti - Self drive",
        price: "1,650€",
        link: "https://shiruqviaggi.com/prodotto/larmonia-dei-contrasti-formula-self-drive/",
        book_now: 'RESERVA YA',
        logo: '/Deals/Logo_Shiruq.jpg',
      },
      {
        title: "Turisanda",
        desc: "Voyager Israel",
        price: "1,860€",
        link: "https://www.turisanda.it/viaggi/israele/tel-aviv/voyager-israel",
        book_now: 'RESERVA YA',
        logo: '/Deals/LOGO_TURISANDA1924_POSITIVO_Pantone_cool_gray_8C(1)(002).jpg',
      },
      
      {
        title: "Kell 12",
        desc: "Israele - Dalla Galilea in Kibutz al deserto del Negev",
        price: "3,690€",
        link: "https://kel12.com/icnc_viaggi/dalla-galilea-in-kibbutz-al-deserto-del-negev-2021/",
        book_now: 'RESERVA YA',
        logo: '/Deals/logokelnewcolor.jpg',
      },
      {
        title: "Viaggi dell'Elefante",
        desc: "Israele, tra storia e cultura",
        price: "2,700€",
        link: "https://www.viaggidellelefante.it/tours/512_israele-tra-storia-e-cultura",
        book_now: 'RESERVA YA',
        logo: '/Deals/ViaggidellElefante.jpg',
      },
      {
        title: "Il Tucano",
        desc: "sraele - la via dell'Incenso, Gerusalemme e la Galilea",
        price: "4,530€",
        link: "https://www.tucanoviaggi.com/index.php?option=com_zoo&task=item&item_id=12703&Itemid=288",
        book_now: 'RESERVA YA',
        logo: '/Deals/logo.jpg',
      },
      
      
  ]
  }

  render() {
    const dealsHtml = this.deals.map((o) => {
      return (
        <DealItem
          key={o.title}
          brand={o.title}
          price={o.price}
          brandImg={o.logo}
          desc={o.desc}
          bookNowLink={o.link}
          descFontSize={o.fontSize}
        />
      );
    });
    return (
      <div className="deals-wrapper">
        <SimpleSlider settings={this.dealsSliderSettings}>{dealsHtml}</SimpleSlider>
      </div>
    );
  }
}

export default Deals;



// WEBPACK FOOTER //
// ./src/Components/Deals/Deals.js